<template>
  <div>
    <h2 class="careering">Content Strategist</h2>
    <p1>Convey the journey of USBs.</p1>
    <div class="spacer"></div>
    <div class="spacer"></div>
    <div class="spacer"></div>
    <p3>
      <b>You’ll be joining</b> a versatile team of two.
      <a href="https://twitter.com/thecpe" target="_blank">Yatú</a> keeps us
      moving as the Head of Reality, while
      <a href="https://twitter.com/usbnorm" target="_blank">Norm</a> keeps us
      imagining as the Head of Fiction. We’re based in New York City building a
      worldwide network.
    </p3>
    <div class="spacer"></div>
    <div class="spacer"></div>
    <FadedImage name="in-the-city-state.png" />
    <div class="spacer"></div>
    <div class="spacer"></div>
    <div class="spacer"></div>
    <p3>
      <b>We're looking for</b> a Content Strategist who can synthesize
      compelling narratives and is excited to carry forward the tone and voice
      that is USB Club.
    </p3>
    <div class="spacer"></div>
    <div class="spacer"></div>
    <p3>You’ll shape our communications by: </p3>
    <ul>
      <li>Strategizing campaigns and external releases.</li>
      <li>Developing and carrying out production processes.</li>
      <li>Fostering and nurturing publishing relationships.</li>
    </ul>
    <div class="spacer"></div>
    <div class="spacer"></div>
    <p3>Skillsets for the role include: </p3>
    <ul>
      <li>Analyzing media and its effects.</li>
      <li>Analyzing distribution channels.</li>
      <li>Familiarity with physical and digital media channels.</li>
      <li>Excellent written and verbal communication.</li>
    </ul>
    <div class="spacer"></div>
    <div class="spacer"></div>
    <p3>
      <b>The application process</b> will include a chat with Yatú followed by a
      chat with Norm.
    </p3>
    <div class="spacer"></div>
    <p3
      >To kickstart this process, reach out to
      <span class="email">y@usbclub.net</span> with your resume, portfolio, and
      a brief explanation of why you’re interested in being a part of the
      journey at USB Club.
    </p3>
    <div class="spacer"></div>
    <p3
      >We’re committed to creating an encouraging environment for all
      collaborators and teammates, and we look forward to hearing from you.
    </p3>
    <div class="spacer"></div>
    <div class="spacer"></div>
    <div class="spacer"></div>
    <div class="spacer"></div>
    <div class="spacer"></div>

    <Footer :fixed="false" />
  </div>
</template>

<script>
import Footer from "../Footer.vue";
import FadedImage from "../FadedImage.vue";

export default {
  name: "ContentStrategist",
  components: {
    Footer,
    FadedImage,
  },
  head() {
    return {
      title: "Content Strategist",
      meta: [
        {
          tagDuplicateStrategy: "replace",
          name: "twitter:title",
          content: "Content Strategist",
        },
        {
          tagDuplicateStrategy: "replace",
          name: "twitter:description",
          content: "Career with us.",
        },
        {
          name: "description",
          content: "Career with us.",
        },
        {
          tagDuplicateStrategy: "replace",
          name: "og:description",
          content: "Career with us.",
        },
        {
          tagDuplicateStrategy: "replace",
          name: "og:title",
          content: "Content Strategist",
        },
      ],
    };
  },
};
</script>
